import {
  AtsJobApplicationHeaderDocument,
  CreateApplicationParticipantDocument,
  DeleteApplicationParticipantDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useParticipantNotifications = (
  applicationId: string,
  accessId: string,
  companyId: string
) => {
  const [createParticipant] = useMutation(CreateApplicationParticipantDocument, {
    variables: { accessId, atsApplicationId: applicationId },
    extractorFn: (data) => data.atsMutations.createAtsApplicationParticipant,
    refetchQueries: [
      {
        query: AtsJobApplicationHeaderDocument,
        variables: {
          companyId,
          accessId,
          atsApplicationIds: [applicationId],
        },
      },
    ],
  })

  const [deleteParticipant] = useMutation(DeleteApplicationParticipantDocument, {
    variables: { accessId: accessId, atsApplicationId: applicationId },
    extractorFn: (data) => data.atsMutations.deleteAtsApplicationParticipant,
    refetchQueries: [
      {
        query: AtsJobApplicationHeaderDocument,
        variables: {
          companyId,
          accessId,
          atsApplicationIds: [applicationId],
        },
      },
    ],
  })

  return {
    createParticipant,
    deleteParticipant,
  }
}
